module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "itineries"
    }
  }, [_c('div', {
    staticClass: "md-layout heading"
  }), _c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('storekeepers-menu'), _c('sort-table', {
    ref: "table",
    staticClass: "itineries-table",
    attrs: {
      "columns": _vm.tableColumns,
      "link": "link",
      "per-page": _vm.perPage,
      "total": _vm.itinerariesAmount,
      "table-id": "storekeepers-itineries-table",
      "tableHeight": "calc(100% - 48px)",
      "showAddButton": false,
      "loadOnScroll": true
    },
    on: {
      "refresh": _vm.getItineraries,
      "item-click": _vm.onItemClick
    },
    scopedSlots: _vm._u([{
      key: "freights",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.freights.length))]
      }
    }, {
      key: "forwarder",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.forwarder !== null ? scope.item.forwarder.login : ''))]
      }
    }, {
      key: "date",
      fn: function(scope) {
        return [(scope.item.date) ? _c('span', [_vm._v(_vm._s(_vm.moment(scope.item.date).format('Do MMMM (DD.MM.YYYY)')))]) : _c('span', [_vm._v("Не установленна")])]
      }
    }, {
      key: "from_stock",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.from_stock ? scope.item.from_stock.name : 'Не установлен'))]
      }
    }, {
      key: "to_stock",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.to_stock ? scope.item.to_stock.name : 'Не установлен'))]
      }
    }, {
      key: "weight",
      fn: function(scope) {
        return [(scope.item.weight) ? _c('span', [_vm._v(_vm._s(scope.item.weight.toFixed(2)))]) : _c('span', [_vm._v("Не указан")])]
      }
    }, {
      key: "size",
      fn: function(scope) {
        return [(scope.item.size) ? _c('span', [_vm._v(_vm._s(scope.item.size.toFixed(2)))]) : _c('span', [_vm._v("Не указан")])]
      }
    }, {
      key: "driver",
      fn: function(scope) {
        return [(scope.item.driver && scope.item.driver.id) ? _c('span', [_vm._v(_vm._s((scope.item.driver && scope.item.driver.fio) ? scope.item.driver.fio : ''))]) : _vm._e(), (scope.item.forwarder && scope.item.forwarder.id) ? _c('span', [_vm._v(_vm._s((scope.item.forwarder && scope.item.forwarder.fio) ? scope.item.forwarder.fio : ''))]) : _vm._e()]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return undefined
      }
    }, {
      key: "status",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "itineraries-status",
          style: (('color: ' + scope.item.status.color + ';'))
        }, [_c('span', [_vm._v(_vm._s(scope.item.status.message))])])]
      }
    }]),
    model: {
      value: (_vm.itineraries),
      callback: function($$v) {
        _vm.itineraries = $$v
      },
      expression: "itineraries"
    }
  })], 1), _c('md-dialog', {
    attrs: {
      "md-active": _vm.deleteDialog,
      "md-theme": "white"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.deleteDialog = $event
      }
    }
  }, [_c('md-dialog-title', [_vm._v("Удалить машрутный лист?")]), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Отмена")]), _c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        _vm.deleteItinerary()
      }
    }
  }, [_vm._v("Удалить")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12aa62f6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/StorekeepersItineraries.vue
// module id = 1043
// module chunks = 0